'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Bike;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function Bike(_ref) {
  var size = _ref.size,
    strokeColor = _ref.strokeColor,
    strokeWidth = _ref.strokeWidth,
    fillColor = _ref.fillColor,
    svgClass = _ref.svgClass;
  var inlineStyling = {
    fill: fillColor,
    stroke: strokeColor,
    strokeWidth: strokeWidth
  };
  return _react2.default.createElement('svg', {
    className: svgClass,
    height: size,
    style: inlineStyling,
    viewBox: '0 0 24 24',
    width: size,
    xmlns: 'http://www.w3.org/2000/svg'
  }, _react2.default.createElement('path', {
    d: 'M15.6333333,6.60337553 L17.4583333,6.60337553 L17.4583333,4.79746835 L15.6333333,4.79746835 L15.6333333,3.90295359 L17.1833333,3.90295359 C16.9083333,3.3628692 16.275,3 15.6333333,3 C14.6333333,3 13.8166667,3.81012658 13.8166667,4.79746835 C13.8166667,5.79324895 14.6333333,6.60337553 15.6333333,6.60337553 L15.6333333,6.60337553 Z M18.275,13.1687764 C15.9083333,13.1687764 14,15.0590717 14,17.5822785 C14,17.8523207 14,18.2151899 14.0833333,18.4852321 L9.81666667,18.4852321 C9.91666667,18.2151899 9.91666667,17.8523207 9.91666667,17.5822785 C9.91666667,15.1518987 7.90833333,13.2616034 5.54166667,13.2616034 C5.275,13.2616034 4.91666667,13.2616034 4.63333333,13.3544304 L4.63333333,12.9915612 C4.63333333,12.0042194 5.36666667,11.1940928 6.275,11.1940928 L7.36666667,11.1940928 L7.36666667,10.7383966 C7.36666667,10.2911392 7.54166667,9.92827004 7.83333333,9.65822785 L11.1666667,6.33333333 C11.4583333,6.06329114 11.8166667,5.87763713 12.275,5.87763713 C12.8333333,5.87763713 13.3666667,6.14767932 13.6333333,6.60337553 L18,10.9240506 L19.5416667,9.38818565 C20.275,10.1139241 20.275,11.1940928 19.5416667,11.9113924 L18.275,13.1687764 Z M10.3666667,10.9240506 L10.5416667,11.1012658 L16.5416667,11.1012658 L12.8333333,8.84810127 L10.3666667,10.9240506 Z M5.63333333,13.8016878 C7.63333333,13.8016878 9.275,15.4219409 9.275,17.4050633 C9.275,19.3797468 7.63333333,21 5.63333333,21 C3.63333333,21 2,19.3797468 2,17.4050633 C2,15.4219409 3.63333333,13.8016878 5.63333333,13.8016878 Z M5.63333333,19.649789 C6.90833333,19.649789 7.90833333,18.6624473 7.90833333,17.4050633 C7.90833333,16.1392405 6.90833333,15.1518987 5.63333333,15.1518987 C4.36666667,15.1518987 3.36666667,16.1392405 3.36666667,17.4050633 C3.36666667,18.6624473 4.36666667,19.649789 5.63333333,19.649789 Z M18.3666667,13.8016878 C20.3666667,13.8016878 22,15.4219409 22,17.4050633 C22,19.3797468 20.3666667,21 18.3666667,21 C16.3666667,21 14.725,19.3797468 14.725,17.4050633 C14.725,15.4219409 16.3666667,13.8016878 18.3666667,13.8016878 Z M18.3666667,19.649789 C19.6333333,19.649789 20.6333333,18.6624473 20.6333333,17.4050633 C20.6333333,16.1392405 19.6333333,15.1518987 18.3666667,15.1518987 C17.0916667,15.1518987 16.0916667,16.1392405 16.0916667,17.4050633 C16.0916667,18.6624473 17.0916667,19.649789 18.3666667,19.649789 Z'
  }));
}
Bike.defaultProps = {
  strokeColor: 'blue',
  strokeWidth: 0,
  fillColor: '#bada55',
  size: 32,
  svgClass: 'sui-SVGicon'
};